import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, unref as _unref, withCtx as _withCtx, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "vue-video" }
const _hoisted_2 = { class: "vue-video-box" }
const _hoisted_3 = {
  key: 0,
  class: "pagination"
}
const _hoisted_4 = ["onClick"]

import { onMounted, ref, nextTick, onUnmounted, computed } from 'vue';
import 'vue3-carousel/dist/carousel.css';
import { Carousel, Slide } from 'vue3-carousel';
import { LabData } from '@/types/LabData';
import ArrowLeft from '@/components/icons/CarouselLeft.vue';
import RecentCard from '@/components/Carousel/RecentCard.vue';
import VideoCard from '@/components/Carousel/VideoCard.vue';
import { MediaFile } from '@/types/manuals';
import { debounce } from '@/utils';


export default /*#__PURE__*/_defineComponent({
  __name: 'CarouselVideoCards',
  props: {
    list: {},
    isVideo: { type: Boolean }
  },
  setup(__props: any) {

const props = __props;

const deviceWidth = ref<number>();
const currentSlide = ref(0);
const carouselRef = ref();
const visibleCards = ref<boolean[]>([]);
const breakpoints = ref();

const hasHiddenCard = ref(false);
const checkHiddenCards = debounce(() => {
  if (!carouselRef.value) { return false; }
  const scrollBox = carouselRef.value.$el;
  const slides = scrollBox.querySelectorAll('.slideEl');
  slides.forEach((el: Element) => {
    hasHiddenCard.value = el.getAttribute('aria-hidden') === 'true';
  });
}, 100);

const updVisibleCards = debounce(() => {
  const scrollBox = carouselRef.value.$el;
  const items: HTMLElement[] = scrollBox.querySelectorAll('.slideEl');
  nextTick(() => {
    visibleCards.value = [];
    Array.from(items).forEach((item) => {
      visibleCards.value.push(item.getAttribute('aria-hidden') === 'false');
    });
  });
}, 100);

const resizeAction = () => {
  updVisibleCards();
  checkHiddenCards();

  deviceWidth.value = window.innerWidth;
};

onMounted(() => {
  deviceWidth.value = window.innerWidth;

  breakpoints.value = {
    // 320 and up
    320: {
      itemsToShow: carouselRef.value.data.maxSlide.value > 0 ? 1.25 : 1,
      snapAlign: 'center',
    },
    480: {
      itemsToShow: carouselRef.value.data.maxSlide.value > 0 ? 2.25 : 2,
      snapAlign: 'center',
    },
    961: {
      itemsToShow: 3,
      snapAlign: 'start',
    },
  };

  updVisibleCards();
  checkHiddenCards();
  window.addEventListener('resize', resizeAction);
});

onUnmounted(() => {
  window.removeEventListener('resize', resizeAction);
});

const goTo = (index: number, isVisible: boolean) => {
  if (isVisible) { return; }
  carouselRef.value.slideTo(index);
};

const slideEnd = () => {
  updVisibleCards();
};

const prev = () => {
  const index = visibleCards.value.findIndex((x: boolean) => x);
  carouselRef.value.slideTo(index - 1);
};
const next = () => {
  const index = visibleCards.value.findLastIndex((x: boolean) => x);
  carouselRef.value.slideTo(index - 1);
};

const isRightArrowDisabled = computed(() => {
  const visibleCount = visibleCards.value.filter((i) => i).length;
  return currentSlide.value === props.list.length - visibleCount;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (hasHiddenCard.value && deviceWidth.value > 960)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["vue-video__arrow vue-video__prev", { disabled: currentSlide.value === 0 }]),
            onClick: prev
          }, [
            _createVNode(ArrowLeft)
          ], 2))
        : _createCommentVNode("", true),
      _createVNode(_unref(Carousel), {
        ref_key: "carouselRef",
        ref: carouselRef,
        modelValue: currentSlide.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((currentSlide).value = $event)),
        breakpoints: breakpoints.value,
        onSlideEnd: slideEnd
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (card, index) => {
            return (_openBlock(), _createBlock(_unref(Slide), {
              key: index,
              class: "slideEl"
            }, {
              default: _withCtx(() => [
                (_ctx.isVideo)
                  ? (_openBlock(), _createBlock(VideoCard, {
                      key: 0,
                      card: card as MediaFile,
                      class: "carousel__slide"
                    }, null, 8, ["card"]))
                  : (_openBlock(), _createBlock(RecentCard, {
                      key: 1,
                      card: card as LabData,
                      class: "carousel__slide"
                    }, null, 8, ["card"]))
              ]),
              _: 2
            }, 1024))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "breakpoints"]),
      (hasHiddenCard.value && deviceWidth.value > 960)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: _normalizeClass(["vue-video__arrow vue-video__next", { disabled: isRightArrowDisabled.value }]),
            onClick: next
          }, [
            _createVNode(ArrowLeft)
          ], 2))
        : _createCommentVNode("", true)
    ]),
    (hasHiddenCard.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibleCards.value, (isVisible, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: `pag-${index}`,
              class: _normalizeClass(["pagination-item", { disabled: isVisible }]),
              onClick: ($event: any) => (goTo(index, isVisible))
            }, null, 10, _hoisted_4))
          }), 128))
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})